<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">MAYBE THEN SHE'LL REALIZE THAT SOME GIRLS DO</p><p class="fsq">“SOME GIRLS DO…and some girls do it better. Leanne Banks pens a winner. Sexy and laugh-out-loud fun!”</p><p class="fsqs">—<strong>Kasey Michaels, author of <em>The Kissing Game</em></strong></p><p class="fsq">“A master of love and laughter, Ms. Banks delights both heart and soul.”</p><p class="fsqs">—<strong><em>Romantic Times</em></strong></p><p class="fsq">“Leanne Banks is clearly a master.”</p><p class="fsqs">—<strong><em>Romance Reader</em></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SomeGirlsDo_fron-1.vue?78b5cf0b